import React, { useEffect, useState } from "react";
import {
  getTotalDiscounts,
  getDiscountedProducts,
  getHistory,
} from "../Services/Service.js";
import "../css/discounts.css";
import { useNavigate, Link } from "react-router-dom";
import Spinner from "./Spinner";
import Backdrop from "@mui/material/Backdrop";

const Discounts = () => {
  const [discounts, setDiscounts] = useState([]);
  const nav = useNavigate();
  const [isHovered, setIsHovered] = useState(false);
  const [selectedTab, setSelectedTab] = useState(100);
  const [products, setProducts] = useState([]);
  const [error, setError] = useState("");
  const [category, setCategory] = useState("");
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false); // Controls the full page backdrop spinner
  const [contentLoader, setContentLoader] = useState(false); // Controls in-content spinner
  const [serviceData, setServiceData] = useState([]);
  const [toggleViewMode, setToggleViewMode] = useState(
    sessionStorage.getItem("view") === "true" ? true : false
  );

  // Function to fetch discounted products for a given discount value
  const fetchDiscountedProducts = async (discountValue) => {
    if (!discountValue) {
      setError("No discount parameter provided.");
      return;
    }

    // Only set content loader here, not the main loader
    setContentLoader(true);
    setError("");

    try {
      const response = await getDiscountedProducts(discountValue);
      setTotal(response?.data?.totalStock);
      setProducts(response?.data?.data);
    } catch (err) {
      setError("Failed to load discounted products. Please try again.");
      console.error(err);
    } finally {
      setContentLoader(false);
    }
  };

  // Function to fetch history list (for "all" tab)
  const fetchHistoryList = async (limit, page, x, catId, sortBy) => {
    // Only set content loader here, not the main loader
    setContentLoader(true);
    try {
      const res = await getHistory(limit, page, x, catId, sortBy);

      if (res.data?.category) {
        setCategory(res.data.category);
      } else {
        setCategory(res.data.vendorName);
      }

      setTotal(res.data.total);
      setServiceData([...res.data?.data]);
    } catch (err) {
      console.log(err.message);
    } finally {
      setContentLoader(false);
    }
  };

  // Function to fetch available discount tabs
  const fetchDiscounts = async () => {
    try {
      const res = await getTotalDiscounts();
      setDiscounts(res?.data?.data || []);
    } catch (error) {
      console.error("Failed to fetch discounts:", error);
    }
  };

  // Initial data fetch on component mount
  useEffect(() => {
    const initializeData = async () => {
      setLoading(true); // Start main loading spinner

      try {
        await fetchDiscounts(); // Fetch discount tabs
        // Fetch initial products/history based on selectedTab
        if (selectedTab === "all") {
          await fetchHistoryList(
            5,
            1,

            "categoryId",
            "a242V2JBRVRVOWZhMDc5YVdWZnQ3UT09",
            " DiscountDESC"
          );
        } else {
          await fetchDiscountedProducts(selectedTab);
        }
      } catch (err) {
        console.error("Error during initial data fetch:", err);
        setError("Failed to load initial data. Please try again.");
      } finally {
        setLoading(false); // End main loading spinner
      }
    };

    initializeData();
  }, []); // Empty dependency array means this runs once on mount

  // Effect for when a discount tab is selected
  useEffect(() => {
    // Prevent re-fetching on initial render if already handled by the first useEffect
    if (!loading) {
      // Only fetch when not in the initial full-page load state
      if (selectedTab === "all") {
        fetchHistoryList(
          5,
          1,

          "categoryId",
          "a242V2JBRVRVOWZhMDc5YVdWZnQ3UT09",
          " DiscountDESC"
        );
      } else {
        fetchDiscountedProducts(selectedTab);
      }
    }
  }, [selectedTab, loading]); // Added loading as a dependency to ensure it runs after initial load completes

  // console.log(selectedTab, "selectedtab");

  return (
    <div className="container py-5 mt-2">
      <div className="row">
        <div className="d-flex justify-content-center mt-4 mb-2">
          <div
            className="accordion my-1 mx-2"
            id="discountFAQ"
            style={{ backgroundColor: "#03364a", padding: "0px" }}
          >
            <div className="accordion-item">
              <h2 className="accordion-header" id="faqOne">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                  aria-expanded="false"
                  aria-controls="collapseOne"
                  style={{ backgroundColor: "#03364a", color: "white" }}
                >
                  Know more about SG and How to claim?
                  <span class="accordion-icon"></span>
                </button>
              </h2>
              <div
                id="collapseOne"
                className="accordion-collapse collapse"
                aria-labelledby="faqOne"
                data-bs-parent="#discountFAQ"
              >
                <div className="accordion-body" style={{ color: "black" }}>
                  SG stands for “Spice Gold” – it’s our in-app reward point
                  system. You earn SG by completing actions in the game.
                </div>
              </div>
            </div>
          </div>
        </div>
        {loading ? ( // Display main loading spinner if `loading` is true
          <Backdrop open={loading}>
            <Spinner />
          </Backdrop>
        ) : (
          <div
            className="d-flex justify-content-between mb-3 p-2 "
            style={{ backgroundColor: "#03364A" }}
          >
            {discounts.map((tab) => (
              <div
                key={tab.discount} // Ensure key is unique, using tab.discount
                onClick={() => setSelectedTab(tab.discount)}
                className={`px-3 py- rounded text-white col-4 d-flex justify-content-center align-items-center`}
                style={{
                  backgroundColor:
                    selectedTab === tab.discount ? "#001F2B" : "#03364A",
                  transition: "all 0.3s",
                }}
              >
                {tab.discount}% OFF
              </div>
            ))}

            <div
              key={"all"}
              onClick={() => setSelectedTab("all")}
              className={`px-3 py-1 text-white  rounded col-4 d-flex justify-content-center align-items-center`}
              style={{
                backgroundColor: selectedTab === "all" ? "#001F2B" : "#03364A",
                transition: "all 0.3s",
              }}
            >
              {"Others"}
            </div>
          </div>
        )}
      </div>

      <div className="row justify-content-center mb-5">
        {contentLoader ? ( // Display content loader when fetching products for a selected tab
          <Backdrop open={contentLoader}>
            {" "}
            <Spinner />
          </Backdrop>
        ) : (
          <>
            {(selectedTab === 80 || selectedTab === 100) && (
              <div>
                {error ? (
                  <div className="text-center text-danger mt-4">
                    <p>{error}</p>
                    <button
                      className="btn btn-red mt-2"
                      onClick={() => fetchDiscountedProducts(selectedTab)}
                    >
                      Retry
                    </button>
                  </div>
                ) : (
                  <div className="products">
                    {products.length > 0 ? (
                      <div className="row">
                        {total < 5 ? (
                          <div className="limited-deal-container d-flex justify-content-center  ">
                            <div className="deal-alert">
                              <div className="deal-content">
                                <span className="alert-icon">🔥</span>
                                <span className="deal-text">
                                  {selectedTab}% OFF TODAY! Only{" "}
                                  <span className="deals-count">{total}</span>{" "}
                                  left
                                </span>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="d-flex justify-content-center mb-3">
                            <h2>Todays Deal</h2>
                          </div>
                        )}

                        {products?.map((item, i) => (
                          <div
                            className={`mb-4 ${
                              !toggleViewMode
                                ? "col-12"
                                : "col-6 col-md-4 col-lg-3 "
                            }`}
                            key={item.productId}
                          >
                            <Link
                              to={`/productdetails/${item.productId}?deal=${selectedTab}`}
                            >
                              <div className="card h-100 p-1 relative">
                                <div
                                  className=" row align-items-center"
                                  style={{
                                    marginLeft: !toggleViewMode ? "0" : "-14px",
                                  }}
                                >
                                  <div
                                    className={`${
                                      !toggleViewMode
                                        ? "col-5 col-lg-2 p-0 ps-md-2"
                                        : "col-12"
                                    }`}
                                  >
                                    <div className="card-image ">
                                      <img
                                        className="img-fluid rounded"
                                        src={item.productImage}
                                        alt=""
                                      />
                                    </div>
                                  </div>
                                  <div
                                    className={`${
                                      !toggleViewMode
                                        ? "col-7 col-lg-10 p-0"
                                        : "col-12"
                                    }`}
                                  >
                                    <div className="card-body">
                                      <h1 className="product-name">
                                        {item.productTitle}
                                      </h1>
                                      <p className="flash-sale m-0">
                                        <span>
                                          MRP &nbsp;{" "}
                                          <span
                                            style={{
                                              textDecoration: "line-through",
                                            }}
                                          >
                                            {" "}
                                            ₹ {item.productPrice}&nbsp;{" "}
                                          </span>{" "}
                                        </span>
                                      </p>
                                      <p className="text-success m-0 ">
                                        {item.discount}
                                      </p>
                                      <p className="product-price-off ">
                                        {!toggleViewMode ? "You Pay:" : "Pay:"}{" "}
                                        {item.spicegold !== 0 ? (
                                          <>
                                            <span className="t-red">
                                              <span
                                                style={{
                                                  fontWeight: "normal",
                                                  color: "white",
                                                }}
                                              >
                                                ₹ {item.offerPrice} +
                                              </span>{" "}
                                              <img
                                                src={
                                                  "/assets/images/spicegold.png"
                                                }
                                                alt=""
                                                style={{
                                                  height: "20px",
                                                  width: "20px",
                                                }}
                                              />{" "}
                                              <span style={{ color: "red" }}>
                                                {item.spicegold}
                                              </span>{" "}
                                              &nbsp;
                                            </span>
                                          </>
                                        ) : (
                                          <>
                                            <span className="t-red">
                                              <span
                                                style={{
                                                  fontWeight: "normal",
                                                  color: "white",
                                                }}
                                              >
                                                ₹ {item.offerPrice} +
                                              </span>{" "}
                                              <img
                                                src={
                                                  "/assets/images/spicegold.png"
                                                }
                                                alt=""
                                                style={{
                                                  height: "20px",
                                                  width: "20px",
                                                  marginBottom: "2.5px",
                                                }}
                                              />{" "}
                                              {0} &nbsp;
                                            </span>
                                          </>
                                        )}
                                      </p>
                                      <div
                                        className="d-flex justify-content-start"
                                        style={{
                                          top: "5px",
                                          right: "5px",
                                          zIndex: 10,
                                          animation:
                                            "pulseStockText 2s infinite",
                                          transform: "rotate(-2deg)",
                                        }}
                                      >
                                        <span
                                          style={{
                                            color: "#FF3B30", // red for urgency
                                            fontSize: "0.8rem",
                                            fontWeight: "500",
                                            backgroundColor:
                                              "rgba(255, 59, 48, 0.1)",
                                            padding: "2px 6px",
                                            borderRadius: "6px",
                                          }}
                                        >
                                          ⚡ Only {item.productStock} left!
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Link>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="text-center text-white mt-4">
                        <div>
                          <img
                            src="./assets/images/oops.png"
                            alt="image"
                            style={{ width: "50%" }}
                          />
                        </div>
                        <h2 class="fw-semibold mb-2 mt-2">
                          Today's stock is sold out.
                        </h2>
                        <div class="subtext">
                          Come back tomorrow for fresh deals
                        </div>

                        <div class="divider-text">OR</div>

                        <button
                          class="btn btn-red mt-2"
                          onClick={() =>
                            nav("/products/a242V2JBRVRVOWZhMDc5YVdWZnQ3UT09")
                          }
                        >
                          check out other products
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
            {selectedTab === "all" && (
              <div>
                {error ? (
                  <div className="text-center text-danger mt-4">
                    <p>{error}</p>
                    <button
                      className="btn btn-red mt-2"
                      onClick={() =>
                        fetchHistoryList(
                          5,
                          1,
                          "a242V2JBRVRVOWZhMDc5YVdWZnQ3UT09",
                          "categoryId",
                          " DiscountDESC"
                        )
                      }
                    >
                      Retry
                    </button>
                  </div>
                ) : (
                  <div className="products">
                    {serviceData.length > 0 ? (
                      <div className="row">
                        <div className="d-flex justify-content-center mb-3 fw-bold">
                          You Might Also Like
                        </div>

                        {serviceData?.map((item, i) => (
                          <div
                            className={`mb-4 ${
                              !toggleViewMode
                                ? "col-12"
                                : "col-6 col-md-4 col-lg-3 "
                            }`}
                            key={item.productId}
                          >
                            <Link
                              to={`/productdetails/${item.productId}?deal=${selectedTab}`}
                            >
                              <div className="card h-100 p-1 relative">
                                <div
                                  className=" row align-items-center"
                                  style={{
                                    marginLeft: !toggleViewMode ? "0" : "-14px",
                                  }}
                                >
                                  <div
                                    className={`${
                                      !toggleViewMode
                                        ? "col-5 col-lg-2 p-0 ps-md-2"
                                        : "col-12"
                                    }`}
                                  >
                                    <div className="card-image ">
                                      <img
                                        className="img-fluid rounded"
                                        src={item.productImage}
                                        alt=""
                                      />
                                    </div>
                                  </div>
                                  <div
                                    className={`${
                                      !toggleViewMode
                                        ? "col-7 col-lg-10 p-0"
                                        : "col-12"
                                    }`}
                                  >
                                    <div className="card-body">
                                      <h1 className="product-name">
                                        {item.productTitle}
                                      </h1>
                                      <p className="flash-sale m-0">
                                        <span>
                                          MRP &nbsp;{" "}
                                          <span
                                            style={{
                                              textDecoration: "line-through",
                                            }}
                                          >
                                            {" "}
                                            ₹ {item.productPrice}&nbsp;{" "}
                                          </span>{" "}
                                        </span>
                                      </p>
                                      <p className="text-success m-0 ">
                                        {item.discount}
                                      </p>
                                      <p className="product-price-off ">
                                        {!toggleViewMode ? "You Pay:" : "Pay:"}{" "}
                                        {item.spicegold !== 0 ? (
                                          <>
                                            <span className="t-red">
                                              <span
                                                style={{
                                                  fontWeight: "normal",
                                                  color: "white",
                                                }}
                                              >
                                                ₹ {item.offerPrice} +
                                              </span>{" "}
                                              <img
                                                src={
                                                  "/assets/images/spicegold.png"
                                                }
                                                alt=""
                                                style={{
                                                  height: "20px",
                                                  width: "20px",
                                                }}
                                              />{" "}
                                              <span style={{ color: "red" }}>
                                                {item.spicegold}
                                              </span>{" "}
                                              &nbsp;
                                            </span>
                                          </>
                                        ) : (
                                          <>
                                            <span className="t-red">
                                              <span
                                                style={{
                                                  fontWeight: "normal",
                                                  color: "white",
                                                }}
                                              >
                                                ₹ {item.offerPrice} +
                                              </span>{" "}
                                              <img
                                                src={
                                                  "/assets/images/spicegold.png"
                                                }
                                                alt=""
                                                style={{
                                                  height: "20px",
                                                  width: "20px",
                                                  marginBottom: "2.5px",
                                                }}
                                              />{" "}
                                              {0} &nbsp;
                                            </span>
                                          </>
                                        )}
                                      </p>
                                      <div
                                        className="d-flex justify-content-start"
                                        style={{
                                          top: "5px",
                                          right: "5px",
                                          zIndex: 10,
                                          animation:
                                            "pulseStockText 2s infinite",
                                          transform: "rotate(-2deg)",
                                        }}
                                      >
                                        <span
                                          style={{
                                            color: "#FF3B30", // red for urgency
                                            fontSize: "0.8rem",
                                            fontWeight: "500",
                                            backgroundColor:
                                              "rgba(255, 59, 48, 0.1)",
                                            padding: "2px 6px",
                                            borderRadius: "6px",
                                          }}
                                        >
                                          ⚡ Only {item.productStock} left!
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Link>
                          </div>
                        ))}
                        <div className="d-flex justify-content-center">
                          <button
                            className="btn btn-red mt-2"
                            onClick={() =>
                              nav("/products/a242V2JBRVRVOWZhMDc5YVdWZnQ3UT09")
                            }
                          >
                            {" "}
                            Explore more Products
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="text-center text-white mt-4">
                        <div>
                          <img
                            src="./assets/images/oops.png"
                            alt="oops!"
                            style={{ width: "50%" }}
                          />
                        </div>
                        <h2 class="fw-semibold mb-2 mt-2">
                          Something went wrong!
                        </h2>

                        <button
                          className="btn btn-red mt-2"
                          onClick={() =>
                            nav("/products/a242V2JBRVRVOWZhMDc5YVdWZnQ3UT09")
                          }
                        >
                          {" "}
                          Go to catalog
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </div>
      <style>
        {`
          @keyframes blink {
            0% { opacity: 1; }
            50% { opacity: 0.7; }
            100% { opacity: 1; }
          }
          .animate-flicker {
            animation: blink 1.2s infinite;
          }
        `}
      </style>
    </div>
  );
};

export default Discounts;
